// extracted by mini-css-extract-plugin
module.exports = {"amountCell":"amountCell__saOiY","split":"split__zGIJv","amount":"amount__MkExI","amountTotal":"amountTotal__WDDJl","total":"total__o6VHM"};